
import { useContext, useEffect, useState } from 'react'

import Axios from 'axios'
import DashboardContext from '../../Context'

import { Link, useHistory } from 'react-router-dom'
import { Accordion, Card } from 'react-bootstrap'
/**
 * این کامپوننت برای نمایش منو کناری است
 */
function Sidbar({showSlider}) {

    const { urldashboard, authentication, handelsidebar, handelloding, handelAdd, handelEdit, handelFromTabel , envirement } = useContext(DashboardContext)

    const [dataslid, setdataslid] = useState([]);

    const { location } = useHistory()

    const [numberindex, setNumberindex] = useState()

    const [isselect, setIsselect] = useState(false)

    const dataFeching = async () => {
        try {
            const res = await Axios.get(`${urldashboard}/accesses/get`, {
                headers: {
                    "Authorization": authentication
                }
            })
            const data = await res.data.data
            setdataslid(data)
            localStorage.setItem("sidebar", JSON.stringify(data))
            handelsidebar(data)
        } catch (error) {
            //console.log(error);
        }
    }


    useEffect(() => {
        if (JSON.parse(localStorage.getItem("sidebar"))) {
            setdataslid(JSON.parse(localStorage.getItem("sidebar")))
        }
        else {
            dataFeching()
        }
    }, [])
    const handelli = () => {
        sessionStorage.setItem('startpage', JSON.stringify(1))
        sessionStorage.setItem('serch', JSON.stringify(""))
        sessionStorage.setItem('pageSize', JSON.stringify(10))
        sessionStorage.setItem('Pagination', JSON.stringify([]))
        sessionStorage.removeItem('customerid')
        sessionStorage.removeItem('workerId')
        sessionStorage.setItem('serchProps', JSON.stringify(''))
        sessionStorage.setItem('pageSizeProps', JSON.stringify(10))
        sessionStorage.setItem('startpageProps', JSON.stringify(1))
        sessionStorage.setItem('PaginationProps', JSON.stringify([]))
        handelFromTabel({})
        handelloding(true)
        handelAdd(false)
        handelEdit('')
    }
    const handelIndex = (number) => {
        if (number === numberindex) {
            setNumberindex()
        }
        else {
            setNumberindex(number)
        }
    }




    const handelClick = (index) => {
        handelIndex(index);
        setIsselect(true)
    }
    return (
        <Accordion className="sidebar sidebar-offcanvas" id="sidebar" defaultActiveKey='' >
            {
                dataslid.map((item, index) => (

                    !item.showInMenu ? null : <Card key={index} style={{ backgroundColor: 'transparent', marginBottom: '0px', boxShadow: 'none' }} >
                        <Accordion.Toggle as={Card.Header} eventKey={item.category.trim().replace(/ /g, '-')}
                            onClick={() => handelClick(index)}
                            className='navSlidCardheader nav submenu-wrapper ' >
                            <div className='d-flex align-baseline justify-content-center' style={{ fontSize: '14px' , cursor : 'pointer' }} >{item.category}
                                <i className={item.controllers.find(el => `/${el.controller}` === location.pathname) ? "fa fa-angle-down mr-auto" : numberindex === index ? "fa fa-angle-down mr-auto" : "fa fa-angle-left mr-auto"} aria-hidden="true"></i>
                            </div>
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey={item.category.trim().replace(/ /g, '-')}
                            className={item.controllers.find(el => `/${el.controller}` === location.pathname) ? isselect ? '' : 'show' : ''}
                        >
                            <Card.Body style={{ padding: '0px' }} >
                              
                                <ul className="nav flex-column sub-menu">
                                    {
                                        item.controllers.map(liitem => (
                                            liitem.showInMenu ?
                                                <li className="nav-item"
                                                    key={liitem.controller} onClick={handelli} >
                                                    <Link
                                                        className={`/${liitem.controller}` === location.pathname ? "nav-link active" : "nav-link"}
                                                        to={`/${liitem.controller}`}>
                                                        {liitem.controllerTitle}
                                                    </Link>
                                                </li>
                                                : null
                                        ))
                                    }
                                </ul>
                            </Card.Body>
                        </Accordion.Collapse>

                    </Card>

                ))
            }
            <p style={{position:"absolute" , bottom:"0" ,right:"10px" , color:"#a0a0a0", textTransform:"uppercase", letterSpacing:"1px"}}>{envirement}</p>
        </Accordion >
        // <nav className="sidebar sidebar-offcanvas" id="sidebar">
        //     <ul className="nav submenu-wrapper">
        //         {
        //             dataslid.map((item, index) => (
        //                 <li
        //                     className={item.controllers.find(el => `/${el.controller}` === location.pathname) ? "nav-item active" : "nav-item"}
        //                     key={index} >
        //                     <a className="nav-link collapsed" data-toggle="collapse"
        //                         href={`#${item.category.trim().replace(/ /g, '-')}`}

        //                         aria-expanded={item.controllers.find(el => `/${el.controller}` === location.pathname) ? true : false}
        //                         aria-controls={item.category.trim().replace(/ /g, '-')}>

        //                         <span className="menu-title">{item.category}</span>

        //                         <i className="menu-arrow"></i>
        //                     </a>
        //                     <div className={item.controllers.find(el => `/${el.controller}` === location.pathname) ? "collapse show" : "collapse"}
        //                         id={item.category.trim().replace(/ /g, '-')} >
        //                         <ul className="nav flex-column sub-menu">
        //                             {
        //                                 item.controllers.map(liitem => (
        //                                     <li className="nav-item"
        //                                         key={liitem.controller} onClick={handelli} >
        //                                         <Link
        //                                             className={`/${liitem.controller}` === location.pathname ? "nav-link active" : "nav-link"}
        //                                             to={`/${liitem.controller}`}>
        //                                             {liitem.controllerTitle}
        //                                         </Link>
        //                                     </li>
        //                                 ))
        //                             }
        //                         </ul>
        //                     </div>
        //                 </li>
        //             ))
        //         }
        //     </ul>
        // </nav>

    )
}
export default Sidbar